/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum VaccinationTitle {
  VaccineG = 'VACCINE_G',
  HatcheryVaccine = 'HATCHERY_VACCINE'
}
